// BL-Y5 result → Visualize: invalidate the catalog, and retire the press-time
// preview only when compute named columns and did not fall back to a slow rebuild.
import type { QueryClient } from "@tanstack/react-query";
import { qk } from "../hooks/queries";
import { retireYieldPreviewField } from "./yieldPreview";
import type { YieldCommitField, YieldCommitResult } from "../types/contract";

export function yieldCommitShouldRetire(field: YieldCommitField): boolean {
  return Boolean(field.columns?.length) && !field.deferred;
}

export function applyYieldCommit(
  qc: QueryClient,
  commit: YieldCommitResult | null | undefined,
): void {
  const fields = commit?.yield_attach?.fields;
  if (!fields?.length) return;
  for (const f of fields) {
    void qc.invalidateQueries({ queryKey: qk.covariates(f.field_id) });
    void qc.invalidateQueries({ queryKey: qk.layers(f.field_id) });
    if (yieldCommitShouldRetire(f)) retireYieldPreviewField(f.field_id);
  }
}
